import { RouteConfig } from 'vue-router'
import { reputationRouteNames } from '@/routes/constants/location'
import { Modules } from '../../util/modules'
import { requireAuthAndLocation } from '../auth'

const ReputationDashboardBuilder = () =>
  import(
      /* Reputation Dashboard Remote from Reputation App */ '@/pmd/pages/reputation/builders/ReputationDashboardBuilder.vue'
  ).then(m => m.default)

const ReviewRequestsBuilder = () =>
  import(
      /* Review Requests Remote from Reputation App */ '@/pmd/pages/reputation/builders/ReviewRequestsBuilder.vue'
  ).then(m => m.default)

const ReviewsBuilder = () =>
  import(
      /* Reviews Remote from Reputation App */ '@/pmd/pages/reputation/builders/ReviewsBuilder.vue'
  ).then(m => m.default)

const VideoTestimonialsBuilder = () =>
  import(
      /* Video Testimonials Remote from Reputation App */ '@/pmd/pages/reputation/builders/VideoTestimonialsBuilder.vue'
  ).then(m => m.default)

const WidgetsBuilder = () =>
  import(
      /* Widgets Creator Remote from Reputation App */ '@/pmd/pages/reputation/builders/WidgetsBuilder.vue'
  ).then(m => m.default)

const ReputationSettingsBuilder = () =>
  import(
    /* webpackChunkName: "reputation-settings-page" */ '@/pmd/pages/reputation/builders/ReputationSettingsBuilder.vue'
  ).then(m => m.default)

const ReputationOnlineListing = () =>
  import(
        /* webpackChunkName: "reputation-online-listing-page" */ '@/pmd/pages/reputation/builders/OnlineListingAppBuilder.vue'
  ).then(m => m.default)

const ReputationGbpOptimization = () =>
  import(
        /* webpackChunkName: "reputation-gbp-optimization-page" */ '@/pmd/pages/reputation/builders/GbpOptimizationBuilder.vue'
  ).then(m => m.default)

export const reputationRoutes: RouteConfig[] = [
  {
    path: 'reputation/overview',
    name: reputationRouteNames.overview,
    meta: { translations: [ Modules.Reputation ] },
    component: ReputationDashboardBuilder,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'reputation/requests',
    name: reputationRouteNames.reviewRequest,
    meta: { translations: [ Modules.Reputation ] },
    component: ReviewRequestsBuilder,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'reputation/reviews/:review_id?',
    name: reputationRouteNames.reviews,
    meta: { translations: [ Modules.Reputation ] },
    component: ReviewsBuilder,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'reputation/video-testimonials',
    name: reputationRouteNames.videoTestimonials,
    meta: { translations: [ Modules.Reputation ] },
    component: VideoTestimonialsBuilder,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'reputation/widget',
    name: reputationRouteNames.widget,
    meta: { translations: [ Modules.Reputation ] },
    component: WidgetsBuilder,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'reputation/settings',
    name: reputationRouteNames.settings,
    meta: { translations: [ Modules.Reputation ] },
    component: ReputationSettingsBuilder,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'reputation/listing',
    name: reputationRouteNames.listing,
    meta: { translations: [ Modules.Yext ] },
    component: ReputationOnlineListing,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'reputation/gbp',
    name: reputationRouteNames.gbp,
    meta: { translations: [ Modules.Yext ] },
    component: ReputationGbpOptimization,
    beforeEnter: requireAuthAndLocation,
  },
]
